"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQuestionChallengeAnswer = void 0;
const _1 = require(".");
function makeQuestionChallengeAnswer(id) {
    return new QuestionChallengeAnswerImp(id);
}
exports.makeQuestionChallengeAnswer = makeQuestionChallengeAnswer;
class QuestionChallengeAnswerImp {
    constructor(id) {
        this.observers = new _1.ObserverList();
        this.memoizedText = new _1.MemoizedString("Answer", this.observers.notify);
        this.memoizedFeedback = new _1.MemoizedString("", this.observers.notify);
        this.memoizedIsCorrect = new _1.MemoizedBoolean(false, this.observers.notify);
        this.memoizedShowFeedback = new _1.MemoizedBoolean(false, this.observers.notify);
        this._id = id;
    }
    get id() {
        return this._id;
    }
    get text() {
        return this.memoizedText.val;
    }
    set text(val) {
        this.memoizedText.val = val;
    }
    get feedbackText() {
        return this.memoizedFeedback.val;
    }
    set feedbackText(val) {
        this.memoizedFeedback.val = val;
    }
    get isCorrect() {
        return this.memoizedIsCorrect.val;
    }
    set isCorrect(val) {
        this.memoizedIsCorrect.val = val;
    }
    get showFeedback() {
        return this.memoizedShowFeedback.val;
    }
    set showFeedback(val) {
        this.memoizedShowFeedback.val = val;
    }
    addObserver(observer) {
        this.observers.add(observer);
    }
    removeObserver(observer) {
        this.observers.remove(observer);
    }
}
